import { render, staticRenderFns } from "./FormItemDetailedView.vue?vue&type=template&id=148b5394&"
import script from "./FormItemDetailedView.vue?vue&type=script&lang=ts&"
export * from "./FormItemDetailedView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports